import GridPartialTitle from '../components/grid-partial-title'
import Container from '../components/ui/container'
import Divider from './Divider'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'partial-header' }>

function PartialHeader(block: BlockProps): ReactElement {
  const { title } = block
  return (
    <>
      <Container>
        <GridPartialTitle title={title} />
      </Container>
      <Divider />
    </>
  )
}

export default PartialHeader
